'use client'
import React from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { AppBar, Tab, Tabs } from '@mui/material'
import { Header } from '../Header'
import { useSession } from 'next-auth/react'

const ipTabs = [
  { label: 'トップ', path: '/' },
  { label: '動画管理', path: '/playlists/' },
  { label: 'アーティスト管理', path: '/artists/' },
  { label: 'レポート', path: '/reports/' },
  { label: 'アカウント管理', path: '/account/' }
]
export const NavBar = () => {
  const router = useRouter()
  const currentPath = usePathname()
  const { data: session } = useSession()
  const tabs = session?.user.workspace === 'admin' ? [
    { label: 'IPホルダー管理', path: '/admin/ip-holders/' },
    { label: '通報管理', path: '/admin/reports/' },
    { label: 'ユーザー管理', path: '/admin/users/' },
    { label: 'ブロック状況', path: '/admin/blocks/' },
    { label: '問い合わせ', path: '/admin/support/' },
    { label: '利用規約', path: '/admin/terms/' }
  ] : ipTabs

  if (currentPath.startsWith('/ip') || currentPath.startsWith('/auth')) {
    return null
  }

  const activeTab = Math.max(tabs.findIndex(({ path }) => path === '/'
    ? currentPath === '/'
    : currentPath === path.slice(0, -1) || currentPath.startsWith(path)), 0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    router.push(tabs[newValue].path)
  }

  return (
    <AppBar position='sticky' elevation={4}>
      <Header />
      <Tabs
        variant='scrollable'
        scrollButtons='auto'
        value={activeTab}
        onChange={handleTabChange}
        textColor='secondary'
        indicatorColor='secondary'
        sx={{ px: 4 }}
      >
        {tabs.map((tab, idx) => (
          <Tab key={idx} label={tab.label} sx={{
            '&.Mui-selected': { fontWeight: 700 }
          }} />
        ))}
      </Tabs>
    </AppBar>
  )
}
